export const studyNl = {
  common: {
    academy: 'Academie',
    brand: 'Deenly Academie',
    studyRoom: 'Studiekamer',
    collection: 'Verzameling',
    map: 'Kaart',
    save: 'Opslaan',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    add: 'Toevoegen',
    close: 'Sluiten',
    search: 'Zoeken…',
    all: 'Alles',
    loading: 'Laden…',
    rename: 'Naam wijzigen',
    name: 'Naam',
    edit: 'Bewerken',
    write: 'Schrijven',
    fromCollection: 'Uit de Verzameling',
    onMap: 'Op de kaart',
    email: 'E-mail',
    password: 'Wachtwoord',
    cards: '{n} kaartje | {n} kaartjes',
    pages: '{n} pagina | {n} pagina’s',
    color: 'Kleur {name}',
    colorColon: 'Kleur: {name}',
    colors: { teal: 'petrol', gold: 'goud', rose: 'roze', sky: 'hemelsblauw', violet: 'violet', slate: 'leigrijs', mint: 'mint', lilac: 'lila', white: 'wit' },
  },
  errors: {
    network: 'Geen verbinding met de server. Controleer je internet en probeer het opnieuw.',
    tooMany: 'Te veel pogingen. Wacht een minuut en probeer het opnieuw.',
    generic: 'Er ging iets mis. Probeer het opnieuw.',
  },
  cardTypes: {
    quran: { label: 'Koran', short: 'Vers' },
    hadith: { label: 'Soenna', short: 'Hadith' },
    scholar: { label: 'Geleerden', short: 'Citaat' },
    root: { label: 'Wortels', short: 'Wortel' },
    note: { label: 'Van mij', short: 'Notitie' },
  },
  templates: {
    fiqh: {
      label: 'Fiqh-vraag',
      hint: 'Wat de regel over iets is: bewijzen uit de Koran en de Soenna, de meningen van geleerden, jouw conclusie.',
      lanes: { question: 'Vraag', quran: 'Koran', sunnah: 'Soenna', opinions: 'Meningen van geleerden', conclusion: 'Conclusie' },
    },
    tafsir: {
      label: 'Tafsir van een vers',
      hint: 'Eén vers of passage: de woorden, de aanleiding van de openbaring, wat de tafsirgeleerden zeggen, lessen.',
      lanes: { ayah: 'Vers', words: 'Woorden en wortels', occasion: 'Aanleiding van de openbaring', tafsirs: 'Tafsirs', lessons: 'Lessen' },
    },
    hadith: {
      label: 'Hadithstudie',
      hint: 'Eén hadith: tekst en bron, sharh, de regels die eruit volgen, lessen.',
      lanes: { text: 'Tekst en bron', sharh: 'Sharh', rulings: 'Regels uit de hadith', lessons: 'Lessen' },
    },
    free: {
      label: 'Vrije kaart',
      hint: 'Een lege kaart zonder kaders, voor al het andere.',
    },
  },
  taskColumns: { todo: 'Te doen', doing: 'Bezig', done: 'Klaar' },
  card: {
    page: 'p. {page}',
    noteLine: 'Notitie: {note}',
  },
  due: {
    late: '{n} d. te laat',
    today: 'vandaag',
    tomorrow: 'morgen',
    in: 'over {n} d.',
  },
  password: {
    length: 'Minstens {n} tekens',
    letters: 'Letters',
    numbers: 'Cijfers',
    match: 'Beide wachtwoorden komen overeen',
    failed: 'Er ging iets mis. Probeer het opnieuw.',
    offline: 'Geen verbinding met de server. Controleer je internet en probeer het opnieuw.',
    tooMany: 'Te veel pogingen. Wacht een minuut en probeer het opnieuw.',
    meter: 'Wachtwoordsterkte',
    show: 'Wachtwoord tonen',
    hide: 'Wachtwoord verbergen',
    caps: 'Caps Lock staat aan',
    privacy: 'Privacy',
    strength: ['Te zwak', 'Zwak', 'Redelijk', 'Sterk', 'Uitstekend'],
  },
  auth: {
    panelBadge: 'Deenly-paneel',
    backToSite: 'Naar de site',
    login: {
      metaTitleAcademy: 'Inloggen · Deenly Academie',
      metaDescAcademy: 'Log in en ga verder met leren bij Deenly Academie.',
      metaTitle: 'Inloggen · Deenly',
      metaDesc: 'Inloggen op het Deenly-paneel.',
      academy: {
        title: 'Welkom terug.',
        accent: 'Ga verder waar je gebleven was.',
        lead: 'Je onderwerpen, bronnen en leeswerk wachten op je.',
        cardTitle: 'Inloggen bij de Academie',
      },
      panel: {
        title: 'Welkom terug.',
        accent: 'Bewerken. Publiceren. Volgen.',
        lead: 'De bibliotheek, lezingen, feed en analyses van Deenly, op één plek.',
        cardTitle: 'Inloggen op het paneel',
      },
      locked: 'Te veel verkeerde pogingen. Om veiligheidsredenen is inloggen gepauzeerd. Probeer het opnieuw over {time}.',
      errors: {
        credentials: 'Dit e-mailadres of wachtwoord klopt niet.',
        invalid: 'Vul een geldig e-mailadres en je wachtwoord in.',
        network: 'Geen verbinding met de server. Controleer je internet en probeer het opnieuw.',
        server: 'Inloggen werkt nu even niet. Probeer het over een minuut opnieuw.',
      },
      notices: {
        reset: 'Je wachtwoord is gewijzigd. Log in met je nieuwe wachtwoord.',
        expired: 'Je sessie is verlopen. Log opnieuw in.',
      },
      noAccount: 'Nog geen account?',
      createFree: 'Maak er gratis een aan',
      teamOnly: 'Alleen teamleden hebben toegang. Een beheerder maakt het account aan.',
      forgot: 'Wachtwoord vergeten?',
      retryIn: 'Opnieuw over {time}',
      submit: 'Inloggen',
    },
    forgot: {
      metaTitle: 'Wachtwoord vergeten · Deenly',
      metaDesc: 'Een link voor een nieuw wachtwoord in je e-mail.',
      invalidEmail: 'Vul een geldig e-mailadres in.',
      title: 'Wachtwoord vergeten?',
      accent: 'Binnen een minuut een nieuw.',
      lead: 'Vul het e-mailadres van je account in en we sturen je een link voor een nieuw wachtwoord. De link is 60 minuten geldig.',
      cardSent: 'Kijk in je e-mail',
      cardLink: 'Link voor een nieuw wachtwoord',
      sentBody: 'Als er een account met het adres {email} bestaat, hebben we zojuist een link voor een nieuw wachtwoord gestuurd. De link is 60 minuten geldig en werkt maar één keer.',
      sentHint: 'Niet ontvangen? Kijk ook in je spam, of vraag over een minuut een nieuwe aan.',
      resend: 'Opnieuw versturen',
      backToLogin: 'Terug naar inloggen',
      send: 'Link versturen',
      remembered: 'Ik weet het weer, terug naar inloggen',
    },
    reset: {
      metaTitle: 'Nieuw wachtwoord · Deenly',
      metaDesc: 'Stel een nieuw wachtwoord in voor Deenly.',
      title: 'Nieuw wachtwoord.',
      accent: 'Eén stap.',
      lead: 'Na de wijziging word je uitgelogd op alle apparaten waarop je bent ingelogd.',
      cardBroken: 'De link is niet compleet',
      cardSet: 'Stel een nieuw wachtwoord in',
      hintBroken: 'Open de hele link opnieuw vanuit de e-mail, of vraag een nieuwe aan.',
      hintAccount: 'Voor het account {email}',
      requestLink: 'Nieuwe link aanvragen',
      newPassword: 'Nieuw wachtwoord',
      repeat: 'Herhaal het nieuwe wachtwoord',
      mismatch: 'De wachtwoorden komen niet overeen.',
      submit: 'Nieuw wachtwoord opslaan',
    },
  },
  signup: {
    metaTitle: 'Nieuw account · Deenly Academie',
    metaDesc: 'Een gratis account voor Deenly Academie: jouw plek om de islam te bestuderen.',
    title: 'Jouw plek',
    accent: 'om de islam te bestuderen.',
    lead: 'Verzen, hadiths en notities op één kaart, je khatma en de boeken die je leest, je verplichtingen van de universiteit. Gratis.',
    cardTitle: 'Nieuw account',
    bullet1: 'Een kaart van kennis: verzen, hadiths, tafsir en notities op één plek',
    bullet2: 'Bewijzen uit de Koran en hadith, gevonden op betekenis',
    bullet3: 'Khatma, boeken en verplichtingen met deadlines, elke dag voor je',
    haveAccount: 'Heb je al een account?',
    signIn: 'Inloggen',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    enterFirstName: 'Vul je voornaam in.',
    enterLastName: 'Vul je achternaam in.',
    repeatPassword: 'Herhaal het wachtwoord',
    mismatch: 'De wachtwoorden komen niet overeen.',
    accept: 'Ik accepteer het {policy}.',
    policy: 'privacybeleid',
    confirmTerms: 'Bevestig dat je het privacybeleid accepteert.',
    submit: 'Account aanmaken',
  },
  layout: {
    closeMenu: 'Menu sluiten',
    today: 'Vandaag',
    spaces: 'Ruimtes',
    newSpace: 'Nieuwe ruimte',
    spacesFailed: 'De ruimtes zijn niet geladen.',
    logout: 'Uitloggen',
    dialogSubtitle: 'Een vak op de universiteit of een persoonlijk doel: hierin staan je onderwerpen, taken en leeswerk.',
    subject: 'Vak',
    goal: 'Doel',
    placeholderGoal: 'bijv. Ramadan 1448',
    placeholderSubject: 'bijv. Usul al-fiqh III',
    create: 'Ruimte aanmaken',
    ideas: {
      usul: 'Usul al-fiqh',
      tafsir: 'Tafsir',
      hadith: 'Hadith',
      arabic: 'Arabisch',
      ramadan: 'Ramadan',
      khatma: 'Khatma',
      hifz: 'Hifz',
      exam: 'Examen',
    },
  },
  today: {
    metaTitle: 'Vandaag · Studiekamer · Deenly Academie',
    metaDesc: 'Je taken, leeswerk en onderwerpen.',
    morning: 'Goedemorgen',
    day: 'Goedemiddag',
    evening: 'Goedenavond',
    promptFiqh: 'De vraag die je onderzoekt (bijv. ‘Is rente haram?’)',
    failed: 'We konden je Studiekamer niet laden.',
    retry: 'Probeer opnieuw',
    weekTasks: 'Taken van deze week',
    allTasks: 'Alle taken',
    noTasks: 'Geen taken met een deadline in de komende zeven dagen.',
    doneAria: 'Klaar: {title}',
    inProgress: 'Bezig',
    reading: 'Leeswerk',
    planTitle: 'Maak een leesplan',
    planBody: 'Een khatma vóór het einde van de ramadan, of een boek voor een examen: je krijgt een dagelijkse maat.',
    addReading: 'Leeswerk toevoegen',
    continue: 'Ga verder waar je gebleven was',
    firstTopic: 'Begin je eerste onderwerp',
    streak: 'Leesdagen op rij',
    days: 'dag | dagen',
    weekAria: 'Deze week: {n} pagina | Deze week: {n} pagina’s',
    weekPages: '{n} pagina deze week | {n} pagina’s deze week',
    saveTip: 'Je kunt een vers ook bewaren terwijl je de Koran leest: met de knop ‘Opslaan’ onder elk vers.',
  },
  collection: {
    metaTitle: 'Verzameling · Studiekamer · Deenly Academie',
    metaDesc: 'Je verzen, hadiths, citaten en notities.',
    subtitle: 'Alles wat je bewaart, één keer, voor zoveel onderwerpen als je wilt.',
    newCard: 'Nieuw kaartje',
    noResults: 'Niets voor deze zoekopdracht.',
    empty: 'Je Verzameling is leeg.',
    emptyBody: 'Bewaar je eerste vers, hadith of citaat uit een boek. Elk kaartje draagt zijn bron, zodat je het later kunt citeren.',
  },
  space: {
    fallback: 'Ruimte',
    namePrompt: 'Naam van de ruimte',
    confirmDelete: 'De ruimte ‘{title}’ verwijderen met alle onderwerpen, taken en leeswerk? De kaartjes blijven in je Verzameling.',
    confirmDeleteTask: 'Taak verwijderen?',
    deleteSpace: 'Ruimte verwijderen',
    navAria: 'Ruimte',
    topics: 'Onderwerpen',
    tasks: 'Taken',
    reading: 'Leeswerk',
    newTopic: 'Nieuw onderwerp',
    taskPlaceholder: 'Nieuwe taak, bijv. ‘Examen usul’',
    deadline: 'Deadline',
    moveLeft: 'Naar links: {title}',
    moveRight: 'Naar rechts: {title}',
    khatmaPlan: 'Khatma-plan',
    book: 'Boek',
    readingEmpty: 'Voeg een khatma of een boek toe dat je leest. Stel je een einddatum in, dan krijg je een dagelijkse maat.',
    fiqhLabel: 'De vraag die je onderzoekt',
    topicName: 'Naam van het onderwerp',
    placeholderFiqh: 'bijv. Is rente haram?',
    placeholderTafsir: 'bijv. Ayat al-Kursi (2:255)',
    placeholderHadith: 'bijv. De hadith over intenties',
    previewFrames: 'De kaart begint met deze kaders',
    previewEmpty: 'Lege kaart',
    openMap: 'Kaart openen',
    task: 'Taak',
    status: 'Status',
    topic: 'Onderwerp',
    noTopic: 'Geen onderwerp',
    notes: 'Notities',
    openTopic: 'Onderwerp openen',
    bookPlaceholder: 'bijv. Ihya Ulum ad-Din, deel 1',
    khatma: 'Khatma',
    author: 'Auteur',
    pageCount: 'Aantal pagina’s',
    khatmaInfo: 'Een khatma telt de 604 pagina’s van de mushaf van Medina; je ziet ook in welke juz je bent.',
    finishBy: 'Ik wil klaar zijn op',
    optional: '(niet verplicht)',
    finishHint: 'Met een datum krijg je een dagelijkse maat: hoeveel pagina’s per dag om op tijd klaar te zijn.',
  },
  reading: {
    confirmDelete: '‘{title}’ verwijderen?',
    khatmaJuz: 'Khatma · juz {juz}',
    until: 'tot {date}',
    finished: 'Klaar. Moge het gezegend zijn!',
    measureMet: 'De maat van vandaag is gehaald ({n} p.).',
    todayOf: 'Vandaag: {read} van {target} pagina. | Vandaag: {read} van {target} pagina’s.',
    readToday: 'Vandaag gelezen: {n} p.',
    reachedPage: 'Ik ben gekomen tot pagina',
    pagePlaceholder: 'Pagina (nu {n})',
    plusPages: '+{n} p.',
  },
  picker: {
    title: 'Uit je Verzameling',
    subtitle: 'Klik op een kaartje om het op de kaart te zetten.',
    empty: 'Hier staan geen kaartjes. Voeg een bron direct op de kaart toe.',
    onMap: 'Op de kaart',
  },
  save: {
    label: 'Opslaan in de Studiekamer',
    saved: 'Opgeslagen in de Verzameling',
  },
  form: {
    confirmDelete: 'Kaartje uit de Verzameling verwijderen? Het verdwijnt ook uit alle onderwerpen waar het in staat.',
    editTitle: 'Kaartje bewerken',
    addTitle: 'Bron toevoegen',
    intoFrame: 'In het kader ‘{frame}’',
    toMapAndCollection: 'Op de kaart en in je Verzameling',
    toCollection: 'In je Verzameling',
    kindAria: 'Soort bron',
    findSurah: 'Soera zoeken',
    surahPlaceholder: 'Soera: naam of nummer',
    surahs: 'Soera’s',
    ayahCount: '{n} vers | {n} verzen',
    noSurah: 'Zo’n soera bestaat niet.',
    surah: 'Soera',
    perCard: 'maximaal 20 per kaartje',
    from: 'Van',
    to: 'Tot',
    loadingAyat: 'Verzen laden…',
    searchHadiths: 'Hadiths zoeken',
    hadithPlaceholder: 'Zoek in de verzameling van Deenly: intenties, intention, riba…',
    hadithNote: 'De verzameling is voorlopig grotendeels in het Engels. Kun je een hadith niet vinden? {link}.',
    hadithManual: 'Voer hem in met de bron',
    searching: 'Zoeken…',
    english: 'Engels',
    noResults: 'Geen resultaten.',
    minLetters: 'Typ minstens drie letters.',
    backToSearch: '← Terug naar zoeken',
    hadithText: 'Tekst van de hadith…',
    scholarText: 'Een citaat of samenvatting van wat de geleerde zei…',
    noteText: 'Jouw notitie…',
    hadithSource: 'Bron: verzameling en nummer',
    scholarSource: 'Werk en auteur',
    hadithSourcePlaceholder: 'bijv. Muslim, 1598',
    scholarSourcePlaceholder: 'bijv. Ibn Qudama, Al-Mughni',
    page: 'Pagina',
    titleOptional: 'Titel (niet verplicht)',
    addNote: 'Voeg je eigen notitie toe aan de bron',
    myNote: 'Mijn notitie',
    notePlaceholder: 'Waarvoor dit een bewijs is, wat voor jou belangrijk is…',
    addToMap: 'Op de kaart zetten',
    saveToCollection: 'Opslaan in de Verzameling',
    deleteFromCollection: 'Verwijderen uit de Verzameling',
  },
  node: {
    notePlaceholder: 'Schrijf…',
    noteEmpty: 'Dubbelklik om te schrijven',
    duplicate: 'Dupliceren',
    textPlaceholder: 'Titel…',
    textEmpty: 'Dubbelklik voor tekst',
    tidyLabel: 'Kaartjes ordenen',
    tidy: 'Ordenen',
    deleteFrame: 'Kader verwijderen',
    frame: 'Kader',
    addInto: 'Toevoegen aan: {title}',
    open: 'Openen',
    removeFromMap: 'Van de kaart halen',
  },
  quick: {
    addToMap: 'Op de kaart zetten',
    placeholder: 'Vers, wortel of onderwerp…',
    hint: 'Bijv. 2:255 · al-baqara 255-257 · yasin 1 · رحم · geduld',
    rootTitle: 'Wortel {root}',
    rootText: 'De woorden uit deze wortel en hoe vaak ze in de Koran voorkomen.',
    surah: 'Soera {n}',
    evidence: 'Bewijzen vinden',
    evidenceHint: 'Zet de 3 dichtstbijzijnde verzen en 3 hadiths op de kaart, elk in zijn eigen kader.',
    noResults: 'Niets hiervoor. Probeer een verwijzing (2:255) of een ander woord.',
    enter: 'Enter: op de kaart',
  },
  explorer: {
    title: 'Verkennen',
    tabs: {
      words: 'Woorden',
      tafsir: 'Tafsir',
      translations: 'Vertalingen',
      related: 'Verzen',
      hadiths: 'Hadiths',
      sharh: 'Sharh',
      lessons: 'Lessen',
      ayat: 'Verzen',
    },
    surah: 'Soera {n}',
    tafsirName: 'Tafsir Al-Mukhtasar',
    tafsirTitle: 'Tafsir Al-Mukhtasar · {ref}',
    tafsirSource: 'Tafsir Al-Mukhtasar, {ref}',
    translationTitle: 'Vertaling: {name}',
    translationSource: 'Koran, {ref}, vertaling: {name}',
    sharhTitle: 'Sharh: {title}',
    sharhSource: 'HadeethEnc.com, uitleg van de hadith',
    lessonTitle: 'Een les uit de hadith',
    lessonsTitle: 'Lessen uit de hadith',
    edge: {
      tafsir: 'tafsir',
      translation: 'vertaling',
      root: 'wortel',
      rootOf: 'wortel {root}',
      hadith: 'hadith',
      sharh: 'sharh',
      lesson: 'les',
      lessons: 'lessen',
      related: 'verwant vers',
      ayah: 'vers',
    },
    backToAyah: 'Terug naar het vers',
    hadithFallback: 'Hadith',
    whatToExplore: 'Wat je kunt verkennen',
    failed: 'Het is niet geladen. Probeer het opnieuw.',
    wordsHint: 'Tik op een woord om de wortel in de hele Koran te zien.',
    noTafsir: 'Voor dit vers is er nog geen tafsir.',
    relatedHint: 'De verzen die qua betekenis het dichtstbij liggen. Sleep ze naar de kaart.',
    noRelated: 'Voor dit vers zijn er geen verwante verzen.',
    hadithsHint: 'De hadiths die qua betekenis het dichtst bij dit vers liggen. Sleep ze naar de kaart.',
    noHadiths: 'Geen hadiths voor dit vers.',
    explanation: 'Uitleg van de hadith',
    noExplanation: 'Voor deze hadith is er geen uitleg.',
    allLessons: 'Alle lessen als één notitie',
    noLessons: 'Voor deze hadith zijn er geen lessen.',
    ayatHint: 'De verzen die qua betekenis het dichtst bij deze hadith liggen.',
    noAyat: 'Geen verwante verzen.',
    rootOnMap: 'Wortel op de kaart',
    rootStats: '{times} in {ayahs}, in {surahs}',
    rootTimes: '{n} keer | {n} keer',
    rootAyahs: '{n} vers | {n} verzen',
    rootSurahs: '{n} soera | {n} soera’s',
    previous: 'Vorige',
    next: 'Volgende',
  },
  topic: {
    fallback: 'Onderwerp',
    newFrame: 'Nieuw kader',
    added: 'Toegevoegd aan de kaart en je Verzameling.',
    removedCount: 'Verwijderd: {n}.',
    cardRemoved: 'Het kaartje is van de kaart gehaald (het blijft in je Verzameling).',
    removed: 'Verwijderd.',
    confirmDelete: 'Dit onderwerp en de kaart ervan verwijderen? De kaartjes blijven in je Verzameling.',
    restOfMap: 'Verder op de kaart',
    copied: 'Gekopieerd. Plak het in Word of Google Docs.',
    tools: {
      search: 'Zoeken en toevoegen',
      note: 'Notitie',
      text: 'Tekst',
      frame: 'Kader',
      ayah: 'Vers',
      hadith: 'Hadith',
      quote: 'Citaat van een geleerde',
    },
    addHere: 'Hier toevoegen',
    edgePlaceholder: 'bijv. bewijst, verklaart',
    deleteArrow: 'Pijl verwijderen',
    emptyTitle: 'Je kaart staat klaar.',
    tipSearch: 'Druk op / en typ een vers (2:255, al-baqara 255), een wortel of een onderwerp.',
    tipExplore: 'Selecteer een vers op de kaart: de woorden, tafsir, vertalingen en verwante verzen gaan open.',
    tipPlus: 'Klik op ＋ in een kader om daar een vers, hadith of citaat toe te voegen.',
    tipDouble: 'Dubbelklik ergens op de kaart voor een notitie, tekst of een nieuw kader.',
    tipArrow: 'Sleep van het puntje op de rand van een kaartje naar een ander: zo krijg je een pijl.',
    copyAsText: 'Kopiëren als tekst',
    emptyDoc: 'De kaart is nog leeg.',
    back: 'Terug',
    document: 'Document',
    presentTitle: 'De kaders als dia’s presenteren',
    present: 'Presenteren',
    deleteTopic: 'Onderwerp verwijderen',
    toolsAria: 'Gereedschap',
    zoomOut: 'Uitzoomen',
    zoomIn: 'Inzoomen',
    fitAll: 'Alles tonen',
    zoomHint: 'Dubbelklik: toevoegen · Shift + slepen: meerdere selecteren · Delete: verwijderen',
    presentationAria: 'Presentatie',
    prevFrame: 'Vorig kader',
    nextFrame: 'Volgend kader',
    finish: 'Stoppen',
    undo: 'Ongedaan maken',
    myNote: 'Mijn notitie',
    wordByWord: 'Woord voor woord',
    tafsir: 'Tafsir',
    link: 'Link',
  },
};
